import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../core/modules/shared.module';

import { FuseMainComponent } from './main.component';
import { FuseContentComponent } from './content/content.component';
import { FuseFooterComponent } from './footer/footer.component';
import { FuseNavbarVerticalComponent } from './navbar/vertical/navbar-vertical.component';
import { FuseToolbarComponent } from './toolbar/toolbar.component';
import { FuseNavigationModule } from '../core/components/navigation/navigation.module';
import { FuseNavbarVerticalToggleDirective } from './navbar/vertical/navbar-vertical-toggle.directive';
import { FuseNavbarHorizontalComponent } from './navbar/horizontal/navbar-horizontal.component';
import { FuseQuickPanelComponent } from './quick-panel/quick-panel.component';

import { FuseShortcutsModule } from '../core/components/shortcuts/shortcuts.module';
import { FuseSearchBarModule } from '../core/components/search-bar/search-bar.module';

import { CambioClave } from './toolbar/toolbar.component';

@NgModule({
    declarations: [
    FuseContentComponent,
    FuseFooterComponent,
    FuseMainComponent,
    FuseNavbarVerticalComponent,
    FuseNavbarHorizontalComponent,
    FuseToolbarComponent,
    FuseNavbarVerticalToggleDirective,
    FuseQuickPanelComponent,
    CambioClave
    
    ],
    imports     : [
    SharedModule,
    RouterModule,
    FuseNavigationModule,
    FuseShortcutsModule,
    FuseSearchBarModule
    ],
    entryComponents: [
    CambioClave
    ],
    exports     : [
    FuseMainComponent
    ]
})

export class FuseMainModule
{
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/main.module.ts